(() => {
'use strict';
const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents/100);
for (const form of document.querySelectorAll('[data-wf-order]')) {
 if (form.dataset.initialized) continue;
 form.dataset.initialized = 'true';
 const q = s => form.querySelector(s);
 const variants = JSON.parse(q('[data-variant-data]').textContent);
 const base = variants.filter(v => !v.title.includes('Crimper')).map(v => ({...v, count:parseInt(v.title,10), cap:v.title.split(' / ')[1] || ''})).filter(v => Number.isSafeInteger(v.count) && v.count > 0);
 if (!base.length) continue;
 const caps = [...new Set(base.map(v => v.cap))];
 const select=q('[data-variant-select]'), button=q('button[type="submit"]'), status=q('[data-order-status]'), crimper=q('[data-crimper-add]');
 const root=form.dataset.root.endsWith('/')?form.dataset.root:form.dataset.root+'/';
 const requestedId = new URLSearchParams(window.location.search).get('variant');
 const requested = variants.find(v => String(v.id) === requestedId);
 const requestedBase = requested && base.find(v => v.title === requested.title.replace(' + 1 Crimper', ''));
 let selected = requestedBase || base.filter(v=>v.cap===caps[0]).sort((a,b)=>a.count-b.count)[0];
 let cap=selected.cap, hasCrimper=false, busy=false;
 if (crimper && requested?.title.includes('Crimper')) crimper.checked=true;
 const capButtons=new Map(), packButtons=new Map();
 const scope=form.closest('.wf-supply');
 const hero=scope?.querySelector('[data-bottle-hero]');
 const heroImg=hero?.querySelector('img'),heroLink=hero?.querySelector('a'),heroCaption=hero?.querySelector('figcaption');
 const original=heroImg?{src:heroImg.getAttribute('src'),srcset:heroImg.getAttribute('srcset'),alt:heroImg.alt,href:heroLink?.href,caption:heroCaption?.textContent}:null;
 const setPhoto=()=>{
   if(!original)return;
   const photos={'Brown Wooden':'https://cdn.shopify.com/s/files/1/1053/8336/2843/files/10ml-brown-wooden-cap-bottle.jpg?v=1791419951','Black Wooden':'https://cdn.shopify.com/s/files/1/1053/8336/2843/files/10ml-black-wooden-cap-bottle.jpg?v=1791420644'};
   const photo=photos[cap];
   heroImg.src=photo||original.src;
   heroImg.removeAttribute('srcset');
   if(!photo && original.srcset)heroImg.setAttribute('srcset',original.srcset);
   heroImg.alt=photo?'Complete 10 mL bottle with '+cap.toLowerCase()+' cap':original.alt;
   if(heroLink)heroLink.href=photo||original.href;
   if(heroCaption)heroCaption.textContent=photo?'Assembled bottle · '+cap+' cap':original.caption;
   for(const detail of scope.querySelectorAll('[data-bottle-detail]'))detail.hidden=!!photo;
 };
 const update=()=>{
   const tool=variants.find(v=>v.title===selected.title+' + 1 Crimper');
   const addTool=!!(crimper?.checked && !hasCrimper && tool?.available);
   select.value=String(addTool?tool.id:selected.id);
   q('[data-unit-price]').textContent=money(selected.price/selected.count)+' per bottle · '+selected.count+' bottles';
   q('[data-order-total]').textContent=money(addTool?tool.price:selected.price);
   const smallest=base.filter(v=>v.cap===cap).sort((a,b)=>a.count-b.count)[0];
   const saving=Math.round(smallest.price/smallest.count*selected.count-selected.price);
   q('[data-savings]').hidden=saving<=0;
   q('[data-savings]').textContent='Save '+money(saving)+' compared with the smallest pack’s price per bottle.';
   setPhoto();
   for(const [name,b] of capButtons) b.setAttribute('aria-pressed',String(name===cap));
   for(const [id,b] of packButtons) b.setAttribute('aria-pressed',String(id===selected.id));
   if(crimper) { q('[data-crimper-choice]').hidden=hasCrimper || !tool?.available; q('[data-crimper-present]').hidden=!hasCrimper; }
   button.disabled=busy || !selected.available;
   button.textContent=selected.available?'ADD BOTTLES':'UNAVAILABLE';
 };
 const renderPacks=()=>{
   const host=q('[data-pack-options]');host.replaceChildren();packButtons.clear();
   for(const v of base.filter(v=>v.cap===cap).sort((a,b)=>a.count-b.count)){
     const b=document.createElement('button');b.type='button';b.className='wf-option';b.disabled=!v.available;
     const number=document.createElement('span');number.textContent=v.count+' bottles';
     const price=document.createElement('small');price.textContent=money(v.price);b.append(number,price);
     b.addEventListener('click',()=>{selected=v;update();});host.append(b);packButtons.set(v.id,b);
   }
   update();
 };
 if(caps.length>1){
   q('[data-cap-field]').hidden=false;
   for(const name of caps){const b=document.createElement('button');b.type='button';b.className='wf-option';b.textContent=name;
   b.addEventListener('click',()=>{const count=selected.count;cap=name;selected=base.find(v=>v.cap===cap && v.count===count)||base.filter(v=>v.cap===cap).sort((a,b)=>a.count-b.count)[0];renderPacks();});
   q('[data-cap-options]').append(b);capButtons.set(name,b);}
 }
 q('[data-native-variant]').hidden=true;q('[data-pack-field]').hidden=false;
 const inspectCart=async()=>{
   const response=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
   if(!response.ok)throw new Error('Unable to check your cart. Please try again.');
   const cart=await response.json();
   hasCrimper=cart.items.some(item=>[10496037290267,10496037323035].includes(item.product_id)||String(item.variant_title||'').includes('Crimper'));
   if(hasCrimper && crimper)crimper.checked=false;
 };
 crimper?.addEventListener('change',update);
 if(crimper)inspectCart().then(update).catch(()=>{crimper.disabled=true;});
 form.addEventListener('submit',async event=>{
   event.preventDefault();if(busy || !selected.available)return;busy=true;update();status.textContent='Adding your order…';
   try {
     if(crimper)await inspectCart();update();
     const properties=form.dataset.freeCrimper==='true'?{'Crimping tool':'Free reusable tool included'}:undefined;
     const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(select.value),quantity:1,properties}]})});
     const result=await response.json();
     if(!response.ok)throw new Error(result.description||result.message||'Your order could not be added. Please try again.');
     try {
       const saved=await fetch(root+'cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
       if(saved.ok){const cart=await saved.json();localStorage.setItem('workflow_supply_list',JSON.stringify(cart.items.filter(item=>[10496037290267,10496037323035,10496037388571,10496037454107,10496037519643,10498333409563].includes(item.product_id)).map(item=>({id:item.variant_id,quantity:item.quantity,title:item.product_title,variant:item.variant_title,properties:item.properties}))));}
     } catch {}
     window.location.assign(form.dataset.cartUrl);
   }catch(error){status.textContent=error.message;busy=false;update();}
 });
 renderPacks();
}
})();